export const AffiliateOptions = [
    { value: "Individual", label: "Individual" },
    { value: "Non-Profit", label: "Non-Profit" },
    { value: "Private Company", label: "Private Company" },
    { value: "Organization", label: "Other Organization" },
];